<template>
    <div class="main">
        <el-form label-position="top">
            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                    <!-- Tipo de relatório -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24">
                            <el-form-item label="Relatório">
                                <el-select v-model="tipo" @change="changeTipo" placeholder="Selecione o relatório" style="width: 100%;">
                                    <el-option v-for="r in relatorios" :key="r.value" :label="r.label" :value="r.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Instituição / Período -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="18">
                            <el-form-item label="Instituição" key="instituicao" v-if="ehSmed">
                                <el-select @change="getTurmas()" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable style="width: 100%;">
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <div class="style-form" v-else>
                                <label>Instituição</label>
                                <div class="style-input readonly">{{ $store.state.config.instituicao ? $store.state.config.instituicao.nome : '' }}</div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="6">
                            <el-form-item label="Período">
                                <el-select @change="getTurmas()" v-model="filtro.periodo_letivo_id" style="width: 100%;">
                                    <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Turma (para relatórios de escopo turma) -->
                    <el-row :gutter="10" v-if="config.turma">
                        <el-col :xs="24" :sm="24">
                            <el-form-item :label="config.turmaObrigatoria ? 'Turma' : 'Turma (opcional)'">
                                <el-select v-model="filtro.turma_id" @change="changeTurma()" clearable filterable placeholder="Selecione a turma" style="width: 100%;">
                                    <el-option-group v-for="(grupo, i) in turmas" :key="i" :label="i">
                                        <el-option v-for="turma in grupo" :key="turma.id" :label="`${turma.curso.nome} ${turma.nome}`" :value="turma.id"></el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Disciplina -->
                    <el-row :gutter="10" v-if="config.disciplina">
                        <el-col :xs="24" :sm="24">
                            <el-form-item :label="config.disciplinaObrigatoria ? 'Disciplina' : 'Disciplina (opcional)'">
                                <el-select v-model="filtro.disciplina_id" clearable filterable placeholder="Selecione a disciplina" style="width: 100%;">
                                    <el-option v-for="d in turmaSelecionada.disciplinas" :key="d.id" :label="d.nome" :value="d.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Intervalo de datas -->
                    <el-row :gutter="10" v-if="config.datas">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Data inicial (opcional)">
                                <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Início" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Data final (opcional)">
                                <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Fim" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" class="u-text-right">
                        <el-button @click="gerar()" type="primary" :disabled="!tipo">
                            <i class="el-icon-printer"></i> GERAR PDF
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    data: () => ({
        tabAtivo: 'filtros',
        tipo: '',
        relatorios: [
            { value: 'conteudo-ministrado',   label: 'Conteúdo ministrado',                    turma: true,  turmaObrigatoria: true,  disciplina: true,  disciplinaObrigatoria: false, datas: true,  escopo: 'turma' },
            { value: 'conteudo-planejado',    label: 'Conteúdo planejado',                     turma: true,  turmaObrigatoria: true,  disciplina: true,  disciplinaObrigatoria: false, datas: true,  escopo: 'turma' },
            { value: 'reprovacao-disciplina', label: 'Resumo de reprovação por disciplina',    turma: true,  turmaObrigatoria: true,  disciplina: false, disciplinaObrigatoria: false, datas: false, escopo: 'turma' },
            { value: 'aproveitamento-final',  label: 'Aproveitamento final por série e turma',  turma: false, turmaObrigatoria: false, disciplina: false, disciplinaObrigatoria: false, datas: false, escopo: 'instituicao' },
            { value: 'rendimento-turma',      label: 'Rendimento por turma',                   turma: true,  turmaObrigatoria: false, disciplina: false, disciplinaObrigatoria: false, datas: false, escopo: 'instituicao' },
            { value: 'matriculas-canceladas', label: 'Matrículas canceladas',                  turma: false, turmaObrigatoria: false, disciplina: false, disciplinaObrigatoria: false, datas: true,  escopo: 'instituicao' },
            { value: 'atribuicao-aulas',      label: 'Atribuição de aulas por turma/disciplina', turma: false, turmaObrigatoria: false, disciplina: false, disciplinaObrigatoria: false, datas: false, escopo: 'instituicao' },
            { value: 'situacao-competencia',  label: 'Situação final por turma e competência', turma: true,  turmaObrigatoria: true,  disciplina: false, disciplinaObrigatoria: false, datas: false, escopo: 'turma' }
        ],
        filtro: {
            instituicao_id: '',
            periodo_letivo_id: '',
            turma_id: '',
            disciplina_id: '',
            data_inicio: '',
            data_fim: ''
        },
        turmas: [],
        turmaSelecionada: {}
    }),
    computed: {
        ehSmed () {
            const t = this.$store.state.user.tipo
            return t == 10 || (t > 3 && t <= 8)
        },
        config () {
            return this.relatorios.find(r => r.value === this.tipo) || {}
        }
    },
    mounted () {
        this.filtro.periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica

        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }

        this.getTurmas()
    },
    methods: {
        changeTipo () {
            // limpa filtros específicos ao trocar de relatório
            this.filtro.turma_id = ''
            this.filtro.disciplina_id = ''
            this.filtro.data_inicio = ''
            this.filtro.data_fim = ''
            this.turmaSelecionada = {}
        },

        getTurmas () {
            this.filtro.turma_id = ''
            this.filtro.disciplina_id = ''
            this.turmaSelecionada = {}

            if (!this.filtro.instituicao_id || !this.filtro.periodo_letivo_id) {
                this.turmas = []
                return
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.filtro.periodo_letivo_id}`, this.$store.getters.getHeaderAuth).then(response => {
                this.turmas = response.data
            }).catch(error => { this.$store.commit('throwException', error) })
        },

        changeTurma () {
            this.filtro.disciplina_id = ''
            this.turmaSelecionada = {}

            for (let grupo in this.turmas) {
                for (let t of this.turmas[grupo]) {
                    if (t.id == this.filtro.turma_id) {
                        this.turmaSelecionada = t
                        return
                    }
                }
            }
        },

        gerar () {
            const c = this.config

            if (c.escopo === 'instituicao' && !this.filtro.instituicao_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione a instituição.', type: 'warning' })
                return
            }
            if (c.escopo === 'instituicao' && !this.filtro.periodo_letivo_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione o período letivo.', type: 'warning' })
                return
            }
            if (c.turmaObrigatoria && !this.filtro.turma_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione a turma.', type: 'warning' })
                return
            }
            if (c.disciplinaObrigatoria && !this.filtro.disciplina_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione a disciplina.', type: 'warning' })
                return
            }

            // Monta o param conforme o escopo do relatório
            const param = {}
            if (c.escopo === 'instituicao') {
                param.instituicao_id = this.filtro.instituicao_id
                param.periodo_letivo_id = this.filtro.periodo_letivo_id
            }
            if (c.turma && this.filtro.turma_id) param.turma_id = this.filtro.turma_id
            if (c.disciplina && this.filtro.disciplina_id) {
                param.disciplina_id = this.filtro.disciplina_id
                const d = (this.turmaSelecionada.disciplinas || []).find(x => x.id == this.filtro.disciplina_id)
                if (d) param.disciplina_nome = d.nome
            }
            if (c.datas) {
                if (this.filtro.data_inicio) param.data_inicio = this.filtro.data_inicio
                if (this.filtro.data_fim) param.data_fim = this.filtro.data_fim
            }

            window.eventBus.$emit('print', {
                url: `/api/relatorio-pedagogico/${this.tipo}`,
                param: param
            })
        }
    }
}
</script>
